<template>
  <v-card>
    <v-card-title class="py-0" style="height: 64px">
      <span class="title">发送短信</span>
      <span class="pl-4 subheading">{{templateInfo.name}}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="max-height: 500px">
      <v-container class="pt-0" fluid grid-list-md>
        <v-form ref="sendForm">
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                label="接收人"
                prepend-icon="mdi-phone"
                validate-on-blur
                :rules="$rules.phone11()"
                v-model="receiver"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                readonly
                prepend-icon="mdi-send"
                label="发送预览"
                v-model="view"
                :rows="1"
                :hint="'使用“{}”包裹的内容为未填入的变量'"
                persistent-hint
                auto-grow
              ></v-textarea>
            </v-flex>
            <v-layout row wrap class="pt-2">
              <v-flex :key="index" xs12 v-for="(v, index) in variables">
                <v-layout align-center row>
                  <v-flex xs3>
                    <v-text-field
                      label="变量名"
                      readonly
                      prepend-icon=" "
                      v-model="v.key"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-textarea
                      :label="v.value"
                      placeholder="手动填入内容"
                      :hint="(moduleLabelSelect.find(l => l.id === v.value) || {}).description || ''"
                      persistent-hint
                      :rows="1"
                      auto-grow
                      v-model="v.content"
                    >
                      <template
                        slot="item"
                        slot-scope="data"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{data.item.id}}</v-list-tile-title>
                          <v-list-tile-sub-title>{{data.item.description}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-textarea>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn large color="grey" flat @click="cancel()">取消</v-btn>
      <v-btn :loading="actionLoading" large color="primary" flat @click="send()">发送</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
let variablePattern = /({[^{}]+})/g
export default {
  name: 'sendDialog',
  props: {
    value: {},
    item: {},
    actionLoading: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    moduleLabels: [],
    templateInfo: {
      originalTemplate: ''
    },
    variables: [],
    receiver: '',
    passJson: {
      'status': 1,
      'msg': '200 OK',
      'data': {
        'PASS|ORDER_ORG': '来访人单位',
        'PASS|ORDER_ID_CARD': '来访人身份证号',
        'PASS|OWNER_PHONE': '受访人电话',
        'PASS|ORDER_PHONE': '来访人电话',
        'PASS|ORDER_OBJECT_CODE': '访客车牌',
        'IM|NOW': '格式为YYYY-MM-DD HH:mm:ss',
        'IM|CURRENT_USER': '根据用户TOKEN获取执行操作用户的用户名',
        'PASS|ORDER_PASS_TIME': '预约时段',
        'PASS|ORDER_NAME': '来访人姓名',
        'PASS|ORDER_PARKLOT': '预约园区',
        'PASS|OWNER_NAME': '受访人姓名'
      }
    },
    vioJson: {
      'status': 1,
      'msg': '200 OK',
      'data': {
        'VIO|OBJECT_CODE': '车牌',
        'VIO|AREA': '违章区域',
        'VIO|VIOLATOR_CODE': '违章用户编码（教工号）信息',
        'IM|NOW': '格式为YYYY-MM-DD HH:mm:ss',
        'IM|CURRENT_USER': '根据用户TOKEN获取执行操作用户的用户名',
        'VIO|VIOLATION': '违章内容',
        'VIO|VIOLATOR_ORG': '该参数依赖于VIO|VIOLATOR,获取违章用户单位信息',
        'VIO|VIOLATION_HISTORY': '历史违章',
        'VIO|FREEZE_INFO': '冻结说明',
        'VIO|TIMES': '违章次数',
        'VIO|MSG': '附加描述'
      }
    }
  }),
  computed: {
    moduleLabelSelect () {
      let select = []
      for (let label of this.moduleLabels) {
        select.push({id: label.value, description: label.text, avatar: '__PLACEHOLDER__'})
      }
      // console.log('get selections', select)
      return select
    },
    moduleList () {
      return this.$store.state.messageManagement.moduleList
    },
    view () {
      let t = this.templateInfo.originalTemplate
      let names = t.match(variablePattern) || []
      let contents = this.variables.map(v => v.content)
      let newText = ''
      for (let i = 0; i < names.length; ++i) {
        let idx = t.indexOf(names[i])
        let content = contents[i] || names[i]
        newText += t.slice(0, idx + names[i].length).replace(names[i], content)
        // console.log(`replace ${idx + names[i].length}`, t.slice(0, idx + names[i].length), names[i], content)
        t = t.slice(idx + names[i].length)
      }
      newText += t
      return newText
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    send () {
      if (!this.$refs.sendForm.validate()) {
        return
      }

      let payload = {
        datas: '',
        to: this.receiver,
        templateId: this.templateInfo.code,
        pipe: 'msg'
      }
      for (var i = 0; i < this.variables.length; i++) {
        payload.datas += this.variables[i].content
        if (i != this.variables.length - 1) {
          payload.datas += ','
        }
      }
      console.log(payload)
      this.$emit('send', payload)
    },
    async getModuleLabels () {
      let module = this.templateInfo.module
      if (module === 'pass') {
        let obj = this.passJson.data
        for (let i in obj) {
          let item = {
            text: obj[i], value: i
          }
          this.moduleLabels.push(item)
        }
      }
      else {
        let obj = this.vioJson.data
        for (let j in obj) {
          let item = {
            text: obj[j], value: j
          }
          this.moduleLabels.push(item)
        }
      }
    },
  },
  created () {
    if (this.item) {
      console.log(this.item)
      this.templateInfo = this.item
      this.getModuleLabels()
      // this.$nextTick(() => {
      console.log(this.templateInfo)
      let json = eval('(' + this.templateInfo.templateJson + ')')
      let vars = this.variables
      if (json instanceof Object) {
        for (let key of Object.keys(json)) {
          vars.push({key: key.slice(1, -1), value: json[key], content: ''})
        }
        console.log('init variables', this.variables)
      }
      // })
    }
  }
}
</script>

<style scoped>

</style>
